import { render } from "./HomeDashboardComment.vue?vue&type=template&id=5c057f7a"
import script from "./HomeDashboardComment.vue?vue&type=script&lang=js"
export * from "./HomeDashboardComment.vue?vue&type=script&lang=js"

import "./HomeDashboardComment.vue?vue&type=style&index=0&id=5c057f7a&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__